/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas(status) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/solicitacoesaditivos?status=${status}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovar(solicitacaoAditivoReprovada) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/solicitacoesaditivos/${solicitacaoAditivoReprovada.solicitacaoAditivoId}/reprovar`,
                solicitacaoAditivoReprovada
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    processar(solicitacaoAditivoId) {
        return axiosJwt
            .patch(
                `${api}/credenciados/uabs/solicitacoesaditivos/${solicitacaoAditivoId}/processar`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
